export const DISTANCE_LEARNING_TIMETABLE = '/distance-learning/timetable'
